import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeService from '../../../Services/OfficeService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. OfficeAdmin always passes the selected setting (crudType=Update,
// with costGroupText pre-resolved by OfficeAdmin.editEmployeeCostGroupSettingsFunction before
// it reaches the wizard), so this is never invoked, but it keeps the windowDescription contract satisfied.
class EmployeeCostGroupSettingEditItem {}

export default class EditEmployeeCostGroupSettingsWindowDescription {
  static titleForEdit = 'Edit Employee Cost Group Setting';
  static itemType = EmployeeCostGroupSettingEditItem;
  static finishButtonLabel = 'Save';
  static messageOnSuccess = 'Employee cost group setting has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: only these fields are posted back.
  // MUST return the promise (wizard contract).
  static serviceFunction = (edited) =>
    OfficeService.EditOfficeEmployeeCostGroupSettings({
      Id: edited.id || null,
      OfficeId: edited.officeId,
      CostGroupLookupItemId: parseInt(edited.costGroupLookupItemId),
      IsIncludedInWeeklyUpdate: edited.isIncludedInWeeklyUpdate === true || edited.isIncludedInWeeklyUpdate === 'true',
      Description: edited.description || '',
    });

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'costGroupText',
          label: 'Cost Group',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'description',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'isIncludedInWeeklyUpdate',
          label: 'Included In Weekly Update',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
      ],
    },
  ];
}
